"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var tooltip_1 = __importDefault(require("relements/build/esm/overlays/tooltip"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
// Icons
var train_svg_1 = __importDefault(require("@src/containers/SubStories/Header/icons/train.svg"));
// Store
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
// Components
var CustomInProgress_1 = __importDefault(require("@src/components/CustomInProgress"));
// Store
var store_1 = __importDefault(require("@src/store"));
// Actions
var BotActions_1 = require("@src/actions/BotActions");
// Utils
var AuditLogs_1 = require("@src/utils/AuditLogs");
var dispatcher_1 = require("@src/dispatcher");
// Constants
var const_1 = require("@src/const");
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
// Styled-Components
var StyledComponets_1 = require("./StyledComponets");
var Header = function (_a) {
    var _b;
    var onSave = _a.onSave, isEdit = _a.isEdit, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.trainingUrl, trainingUrl = _d === void 0 ? '' : _d, _e = _a.zipFolderUrl, zipFolderUrl = _e === void 0 ? '' : _e, _f = _a.fetchStatus, fetchStatus = _f === void 0 ? function () { } : _f, _g = _a.trainingInProgress, trainingInProgress = _g === void 0 ? false : _g, _h = _a.documentsUploading, documentsUploading = _h === void 0 ? false : _h, _j = _a.setTrainingInProgress, setTrainingInProgress = _j === void 0 ? function () { } : _j, _k = _a.isZipFolderValidated, isZipFolderValidated = _k === void 0 ? true : _k, _l = _a.showMissingInfoPopup, showMissingInfoPopup = _l === void 0 ? function () { } : _l;
    var domain = (_b = CommonStore_1["default"].getMetaTags()) === null || _b === void 0 ? void 0 : _b.domain;
    react_1["default"].useEffect(function () {
        fetchStatus();
    }, [fetchStatus]);
    var ConfirmationDialogueBox = function () {
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement("span", null, " Do you wish to Train the Bot?"),
            react_1["default"].createElement(StyledComponets_1.WarningBox, null,
                react_1["default"].createElement(StyledComponets_1.StyledUl, null,
                    react_1["default"].createElement("li", null, "Kindly note that each training session comes with a cost implication, so please consider carefully before clicking the \"Train\" Button."),
                    react_1["default"].createElement("li", null, "Reserve training only for genuine improvements.")))));
    };
    var trainWebGuide = function () {
        var _a, _b;
        var _c = CommonStore_1["default"].getCurrentBotSettings().bot_properties, botProperties = _c === void 0 ? {} : _c;
        var companyDescription = (_a = botProperties === null || botProperties === void 0 ? void 0 : botProperties.company_context) === null || _a === void 0 ? void 0 : _a.trim();
        var replyTagsObject = (botProperties === null || botProperties === void 0 ? void 0 : botProperties.reply_tags) || {};
        var languageCode = Object.keys(replyTagsObject)[0];
        var replyTags = replyTagsObject[languageCode] || {};
        var companyName = (_b = replyTags['%company']) === null || _b === void 0 ? void 0 : _b.trim();
        if (!companyDescription || !companyName) {
            showMissingInfoPopup();
            return;
        }
        var domainTitle = domain.title;
        var domainId = domain.id;
        var headers = AuditLogs_1.getAuditHeaders({
            domain: domain,
            eventName: 'train_webguide',
        });
        var mixPanelTracker = store_1["default"].getMixPanel();
        dispatcher_1.dispatch(MogamboConstants_1.ActionTypes.OPEN_CONFIRMATION_DIALOG, {
            callback: function () {
                BotActions_1.deployWebguide(domainTitle, headers, domainId, {
                    validate_urls: false,
                    action: 'webguide',
                    training_type: 1,
                }, function () {
                    // Set the in training flag as true and then again fetch after 3 secs from backend to confirm this.
                    setTrainingInProgress(true);
                    setTimeout(fetchStatus, 4000);
                });
            },
            title: 'Train Bot - AISS',
            message: react_1["default"].createElement(ConfirmationDialogueBox, null),
            okTitle: 'Train',
            cancelTitle: 'Cancel',
        });
        mixPanelTracker.track({
            event: const_1.MIX_PANEL.WEBGUIDE.TRAINING_STARTED,
            payload: {
                'Bot Name': domainTitle,
                Account: domain.client,
            },
        });
    };
    var getTrainButtonTooltip = function () {
        if (zipFolderUrl && documentsUploading)
            return 'ZIP Folder Link validation is in progress.';
        if (isEdit)
            return 'Save the changes in order to start the training';
        if (zipFolderUrl && !isZipFolderValidated)
            return 'Kindly address the errors associated with the ZIP file to re-enable training';
    };
    var getSaveButtonTooltip = function () {
        if (documentsUploading)
            return 'Documents are uploading';
        if (trainingInProgress)
            return 'Training in progress';
        return 'Save will be enabled once you edit something';
    };
    var isTrainButtonDisabled = function () {
        return (isEdit ||
            (zipFolderUrl && (documentsUploading || !isZipFolderValidated)));
    };
    var getButtonContent = function () {
        if (documentsUploading)
            return react_1["default"].createElement(CustomInProgress_1["default"], { text: "Uploading" });
        return 'Save';
    };
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(box_1["default"], { padding: "0", justifyContent: "space-between", alignItems: "center" },
            react_1["default"].createElement(text_1["default"], { variant: "h1.semi-bold", color: "black.haptik" }, "AI Site Sync"),
            react_1["default"].createElement(box_1["default"], { padding: "0" },
                !isEdit || documentsUploading || trainingInProgress ? (react_1["default"].createElement(tooltip_1["default"], { themed: true, tooltip: getSaveButtonTooltip(), position: "BOTTOM" },
                    react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, onClick: onSave, disabled: !isEdit ||
                            disabled ||
                            documentsUploading ||
                            trainingInProgress, type: button_1["default"].TYPES.PRIMARY, isInProgressButton: documentsUploading }, getButtonContent()))) : (react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, onClick: onSave, disabled: !isEdit || disabled, type: button_1["default"].TYPES.PRIMARY }, "Save")),
                isTrainButtonDisabled() ? (react_1["default"].createElement(tooltip_1["default"], { themed: true, tooltip: getTrainButtonTooltip(), position: "BOTTOM" },
                    react_1["default"].createElement(StyledComponets_1.TrainButton, { themed: true, disabled: true, variant: "disabled" },
                        react_1["default"].createElement(box_1["default"], { padding: "0", alignItems: "center" },
                            react_1["default"].createElement(icon_1["default"], { src: train_svg_1["default"] }),
                            trainingInProgress ? (react_1["default"].createElement(CustomInProgress_1["default"], { text: "Training" })) : ('Train Bot'))))) : (react_1["default"].createElement(StyledComponets_1.TrainButton, { themed: true, disabled: disabled || trainingInProgress, onClick: disabled || trainingInProgress ? null : trainWebGuide, variant: disabled || trainingInProgress ? 'disabled' : 'secondary' },
                    react_1["default"].createElement(box_1["default"], { padding: "0", alignItems: "center" },
                        react_1["default"].createElement(icon_1["default"], { src: train_svg_1["default"] }),
                        trainingInProgress ? (react_1["default"].createElement(CustomInProgress_1["default"], { text: "Training" })) : ('Train Bot')))))),
        react_1["default"].createElement(StyledComponets_1.StyledText, { variant: "body.lg", color: "black.haptik", marginTop: "10px", marginBottom: "16px" }, "Train your Bot to intelligently answer customer FAQs just from the content of your Website.")));
};
exports["default"] = Header;
